export const Bio = {
  name: "Omkar Lolage",
  roles: [
    "Full Stack Developer",
    "Flutter Developer",
    "UI/UX Designer",
    "Programmer",
  ],
  description:
    "I am a skilled developer and a curious learner based in Pune, India. 🚀 I have a passion for creating beautiful and interactive applications with modern technologies and frameworks. In addition to web development, I have a strong interest and knowledge in Flutter, Cybersecurity, and Java. \n Currently, I'm a student at VIT College in Pune, India 🎓, where I continue to learn and grow in the world of technology.If you have any cool projects or ideas that you want to collaborate on, please feel free to contact me! 🤝 Let's code and innovate together! ",
  github: "https://github.com/omkarlolage21",
  resume:
    "https://drive.google.com/file/d/1qVoe2zlg7L6QvB9UrSt4Ezvt0yw958TF/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/omkar-lolage-2135vo",
  insta: "https://www.instagram.com/omkar.lolage21",
  mail: "mailto:lolageomkar5@gmail.com",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "Flutter",
        image:
          "https://cdn-images-1.medium.com/max/1200/1*5-aoK8IBmXve5whBQM90GA.png",
      },
      {
        name: "Angular",
        image: "https://www.vectorlogo.zone/logos/angular/angular-icon.svg",
      },
      {
        name: "ReactJS",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Spring",
        image: "https://www.vectorlogo.zone/logos/springio/springio-icon.svg",
      },
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "Express Js",
        image: "https://www.vectorlogo.zone/logos/expressjs/expressjs-icon.svg",
      },
      {
        name: "Google Cloud Platform (GCP)",
        image: "",
      },
    ],
  },
  {
    title: "Databases",
    skills: [
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
      {
        name: "Firebase",
        image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
      },
      {
        name: "Cassandra",
        image: "https://www.vectorlogo.zone/logos/springio/springio-icon.svg",
      },
      {
        name: "Astra DB",
        image: "",
      },
    ],
  },
  {
    title: "Programming Languages",
    skills: [
      {
        name: "C",
        image: "",
      },
      {
        name: "C++",
        image: "",
      },
      {
        name: "Java",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
      },
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "Google Apps script",
        image: "",
      },
      {
        name: "Git",
        image: "https://www.vectorlogo.zone/logos/git-scm/git-scm-icon.svg",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "Docker",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg",
      },
      {
        name: "Postman",
        image:
          "https://www.vectorlogo.zone/logos/getpostman/getpostman-icon.svg",
      },
      {
        name: "Figma",
        image: "https://www.vectorlogo.zone/logos/figma/figma-icon.svg",
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/gdsc.jpeg?alt=media&token=c162329c-efaa-4be8-a173-8d3f4c48ea70",
    role: "App Developer",
    company: "Google Developer Student Club",
    date: "Oct 2023 - Present",
    desc: "Working on the application development by collaborating with a team of experienced developers and developing new projects",
    skills: [
      "Flutter",
      "Git",
      "Figma",
      "Android Studio",
      "HTML",
      "CSS",
      "JavaScript",
      "Interpersonal Skills",
      "Cybersecurity",
    ],
    // doc:"Hello",
  },
  {
    id: 1,
    img: "https://avatars.githubusercontent.com/u/72554182?s=200&v=4",
    role: "App Developer",
    company: "CSI, VIT Pune",
    date: "Aug 2023 - June 2024",
    desc: "Working on the mobile app development projects of the club as a technical member",
    skills: [
      "Flutter",
      "Git",
      "Figma",
      "Android Studio",
      "HTML",
      "CSS",
      "JavaScript",
      "Interpersonal Skills",
      "Artificial Intelligence",
    ],
  },
];

export const education = [
  {
    id: 0,
    school: "Vishwakarma Institute of Technology, Bibwewadi, Pune",
    date: "Jan 2022 - June 2026",
    grade: "9.01 CGPA",
    desc: "I am currently pursuing a Bachelor's degree in Computer Engineering at Vishwakarma Institute of Technology, Pune. I have completed 3 semesters and have a CGPA of 9.01. I have taken courses in Data Structures, Algorithms, Microprocessors and Microcontrollers, Operating Systems, Computer Graphics, and Theory of Computation among others. I am also a member of the Google Developers Student Club (GDSC) at VIT, where I am learning and working on exciting projects with a team of talented developers.",
    degree: "Bachelor of Technology - BTech, Computer Engineering",
  },
  {
    id: 1,
    school:
      "Modern College of Arts, Science and Commerce, Shivajinagar, Pune-05",
    date: "2020 - Mar 2022",
    grade: "86.5%",
    desc: "I completed my class 12 high school education at Modern College, Shivajinagr, where I studied Science with Information Technology.",
    degree: "HSC(XII), Science with IT",
  },
  {
    id: 2,
    school: "Sadhana English Medium School, Hadapsar, Pune",
    date: "June 2018 - Mar 2020",
    grade: "91.4%",
    desc: "I completed my class 10 education at Sadhana English Medium School, Pune.",
    degree: "SSC(X)",
  },
];

export const projects = [
  {
    id: 0,
    title: "C-Impressions",
    date: "Dec 2022 - Mar 2022",
    description:
      "C-Impressions is a mobile application developed in flutter. It calculates carbon footprints of the user by taking user parameters. It has a simple authentication using spring and MySQL",
    image:
      "https://media.licdn.com/dms/image/D4D2DAQGzaamrFOTYnQ/profile-treasury-image-shrink_1920_1920/0/1687332156282?e=1704708000&v=beta&t=aBI3heQyOzrjQRfS_55wC6uQp4sJvLJdZ1LgZfn7-YE",
    tags: ["Flutter", "Spring", "MySQL"],
    category: "App Dev",
    github: "https://github.com/omkarlolage21",
  },
  {
    id: 1,
    title: "Quizzy",
    date: "Dec 2022 - Mar 2022",
    description:
      "An offline quiz-game android application developed in Android Studio where users can play quizzes according to their favourite domains like sports, cartoon,etc",
    image:
      "https://media.licdn.com/dms/image/D4D2DAQHJ_7JvtP1AMg/profile-treasury-image-shrink_1920_1920/0/1687332485829?e=1704708000&v=beta&t=3WLhKlrWPWk0qNu0tkf-1awIQsvjb93DNJklALZVa0o",
    tags: ["Android", "Java"],
    category: "App Dev",
    github: "https://github.com/OmkarLolage21/Quiz-Game",
    //   member: [
    //     {
    //       name: "Rishav Chanda",
    //       img: "https://avatars.githubusercontent.com/u/64485885?v=4",
    //       linkedin: "https://www.linkedin.com/in/rishav-chanda-b89a791b3/",
    //       github: "https://github.com/rishavchanda/",
    //     },
    //     {
    //       name: "Upasana Chaudhuri",
    //       img: "https://avatars.githubusercontent.com/u/100614635?v=4",
    //       linkedin: "https://www.linkedin.com/in/upasana-chaudhuri-2a2bb5231/",
    //       github: "https://github.com/upasana0710",
    //     },
    //   ],?
  },
];

export const TimeLineData = [
  { year: 2020, text: "Completed SSC" },
  { year: 2022, text: "Completed HSC" },
  { year: 2023, text: "Completed FY with some projects" },
  {
    year: 2024,
    text: "Completed SY with solid skills and DSA. CSI'23 tenure completed.",
  },
];
